(function () {
  function initDrawingRules(root) {
    if (!root || root.dataset.llDrawingRulesReady === 'true') return;

    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    const panelTrack = root.querySelector('.ll-drawing-rules__panels');
    let heightReleaseTimer;
    if (!tabs.length || tabs.length !== panels.length) return;

    function getActiveIndex() {
      return Math.max(0, tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
    }

    function setPanelHeight(panel) {
      if (!panelTrack || !panel) return 0;
      const height = panel.offsetHeight;
      panelTrack.style.height = `${height}px`;
      return height;
    }

    function releasePanelHeight() {
      window.clearTimeout(heightReleaseTimer);
      if (panelTrack) panelTrack.style.height = '';
    }

    function activate(index, focus) {
      const previousPanel = panels[getActiveIndex()];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (panelTrack && previousPanel && previousPanel !== panels[index] && !reducedMotion) {
        setPanelHeight(previousPanel);
      }

      tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        panels[tabIndex].hidden = !active;
      });

      if (panelTrack) {
        if (reducedMotion || previousPanel === panels[index]) {
          releasePanelHeight();
        } else {
          window.requestAnimationFrame(() => {
            setPanelHeight(panels[index]);
            heightReleaseTimer = window.setTimeout(releasePanelHeight, 260);
          });
        }
      }

      if (focus) tabs[index].focus();
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index, false));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        activate(next, true);
      });
    });

    if (panelTrack) {
      panelTrack.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'height') releasePanelHeight();
      });
      window.addEventListener('resize', releasePanelHeight);
    }

    root.dataset.llDrawingRulesReady = 'true';
    activate(getActiveIndex(), false);
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-ll-drawing-rules]').forEach(initDrawingRules);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
